module.exports = __webpack_public_path__ + "img/racecourse-greyville-turf-800.68797f52.svg";